<template>
  <div class="quantity-selector-dropdown">
    <select v-model="value" name="quantity">
      <option v-for="n in maxQuantity" :key="n" :value="n">
        {{ quantitySelectorText(n) }}
      </option>
    </select>
    <svg class="icon icon-cheveron-down">
      <use xlink:href="#icon-cheveron-down" />
    </svg>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'quantity',
    event: 'change'
  },
  props: {
    quantity: {
      type: Number,
      required: true
    },
    multiplier: {
      type: Number
    },
    singularTextRaw: {
      type: String
    },
    pluralTextRaw: {
      type: String
    },
    inventoryQuantity: {
      type: Number
    }
  },

  data() {
    return {
      maxQuantity: 10
    };
  },

  computed: {
    value: {
      get() {
        return this.quantity;
      },
      set(newVal) {
        return this.$emit('change', newVal);
      }
    }
  },

  watch: {
    inventoryQuantity: {
      immediate: true,
      handler: 'getMaxQuantity'
    }
  },

  methods: {
    quantitySelectorText(value) {
      let textRaw = '';

      if (value > 1) {
        textRaw = this.pluralTextRaw;
      } else {
        textRaw = this.singularTextRaw;
      }

      return textRaw
        .replace('{{ box_count }}', value)
        .replace('{{ quantity }}', value * this.multiplier);
    },
    getMaxQuantity(inventoryQuantity) {
      if (inventoryQuantity < 1) {
        this.maxQuantity = 1;
      } else if (inventoryQuantity > 10) {
        this.maxQuantity = 10;
      } else {
        this.maxQuantity = inventoryQuantity;
      }
    }
  }
};
</script>
